// backend の officeinput.MinStartLeadDays と同値。権威は backend の検証で、ここは
// 選べない日を事前に塞ぐための UX 用の写し (値を変えても backend は連動しない)。
export const MIN_START_LEAD_DAYS = 8;

export function minStartDate(today: Date): Date {
  const d = new Date(today);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + MIN_START_LEAD_DAYS);
  return d;
}
